import { legalLinks, navGroups, serviceLinks } from '../data/navigation';
import type { NavGroup, NavLink } from '../types/navigation';

export type ResolvedPage = {
  page: NavLink;
  group?: NavGroup;
};

export function getAllPages(): ResolvedPage[] {
  const pages: ResolvedPage[] = [];
  navGroups.forEach((group) => {
    pages.push({ page: { label: group.label, path: group.path, description: group.intro }, group });
    group.links.forEach((link) => pages.push({ page: link, group }));
  });
  [...serviceLinks, ...legalLinks].forEach((link) => pages.push({ page: link }));
  return pages;
}
